<template>
  <div>
    <!-- empty Data component -->
    <empty-data v-if="emptyDataFlag" v-bind:text="emptyDataText"></empty-data>
    <!-- 신청서 리스트 -->
    <v-list v-else flat class="doc-list">
      <v-list-item-group>
        <v-list-item
          v-for="item in searchList"
          :key="item.orgApplSeq"
          @click="nextPage(item)"
        >

          <v-list-item-content class="card-list mb-3" :class="item.applYn === 'N'?'disabled':''">
            <!--v-list-item-title class="doc-title">{{
              item.title
            }}</v-list-item-title-->
            <!--아이콘+타이틀+화살표 영역-->



            <div
              class="d-flex justify-space-between align-center card-title-area mb-3"
            >
              <v-list-item-icon class="avatar-wrap mr-2">
                <v-avatar size="24" class="with-icon">
                  <icon-birth :width="24" :height="24" />
                </v-avatar>
              </v-list-item-icon>
              <v-list-item-title class="doc-title ma-0">
                <span> {{ item.orgFamNm }} </span>
              </v-list-item-title>
              <v-list-item-icon class="align-self-center ml-1 pa-0">
                <v-btn fab text width="24" height="24" color="grey">
                  <v-icon size="24">mdi-chevron-right</v-icon>
                </v-btn>
              </v-list-item-icon>
            </div>
            <!-- 개발중 -->
            <v-list-item-subtitle
              class="draft-wrap d-flex justify-space-between"
            >
              <span class="sub-title">휴직기간 </span>
              <span class="sub-date"> {{ item.orgStaYmd+ ' ~ ' +item.orgTmpRestEndPlanYmd }}</span>
            </v-list-item-subtitle>
            <v-list-item-subtitle
              class="draft-wrap d-flex justify-space-between"
            >
              <span class="sub-title">사용일수</span>
              <span class="sub-date">{{ useDay(item) }}</span>
            </v-list-item-subtitle>
            <v-list-item-subtitle
              class="draft-wrap d-flex justify-space-between"
            >
              <span class="sub-title">복직예정일</span>
              <span class="sub-date">{{ item.orgReinstPlanYmd }} </span>
            </v-list-item-subtitle>
            <v-list-item-subtitle
              class="draft-wrap d-flex justify-space-between"
            >
              <span class="sub-title">신청일</span>
              <span class="sub-date">{{ item.orgApplYmd }}</span>
            </v-list-item-subtitle>
            <!--추가문구시 주석해제-->
            <!--v-list-item-subtitle
                class="caution"
            >
              ※ 주의사항입니다.
            </v-list-item-subtitle-->

          </v-list-item-content>

        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
/* 내 신청서 리스트 컴포넌트 */
import EmptyData from '@/components/common/EmptyData.vue';
import dayjs from 'dayjs';
import messageConstants from '@/const/messageConstants.js';
import { getExtParLeaDtAppList, getExtParAddAppList  , getGenderNm} from '@/api/workStatus';
import { mapGetters } from 'vuex';
import routerNames from '@/const/routerConstants';
import applCode from '@/const/applCodeConstants';
import IconBirth from '@/assets/customIcon/IconBirth.vue';

export default {
  props: {
    // 조회요청구분 (MYDOC:내문서, TEMP:임시저장문서, CANCEL:취소신청문서)
    searchReqGubun: {
      type: String,
    },
    // 조회신청서코드 (근태취소신청, 보상휴가취소신청일때만 전달)
    searchApplCd: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      emptyDataFlag: false, // 조회결과없음 플래그
      searchList: [],
      emptyDataText: messageConstants.emptyDataMsg_1,
    };
  },
  computed: {
    ...mapGetters('DIALOG', ['GET_DIALOG_CALLBACK']),
    ...mapGetters('ELA', ['GET_APPL_CD1']),
    ...mapGetters(['GET_APPL_CD']),

    stepChipClass() {
      return applStatusCd => {
        return {
          // 신청서상태코드 (21,31,98:결재처리중,수신처리중,승인요청중 / 23,33:결재반려,수신반려 / 99:처리완료)
          draft: applStatusCd == 23 || applStatusCd == 33,
          charge:
            applStatusCd == 21 || applStatusCd == 31 || applStatusCd == 98,
          approval: applStatusCd == 99,
        };
      };
    },
  },
  watch: {
    GET_DIALOG_CALLBACK(callback) {
      if (callback) {
        this.fetchMyBoxList();
      }
    },
  },
  methods: {
    /* 내문서함 목록조회 */
    async fetchLeaAbsApplList() {
      const paramObj = {
        searchReqGubun: this.searchReqGubun,
        searchApplCd: this.searchApplCd,
        searchSdate:
          this.searchReqGubun === 'TEMP'
            ? ''
            : dayjs().add(-1, 'month').format('YYYYMMDD'),
        searchEdate:
          this.searchReqGubun === 'TEMP' ? '' : dayjs().format('YYYYMMDD'),
        nowYmd: dayjs().format('YYYYMMDD'),
      };

      try {
        let response = [];
        this.$store.commit('SET_APPL_CD', this.GET_APPL_CD1);
        if (this.GET_APPL_CD1 === applCode.LeaAbsAdd) {
          response = await getExtParAddAppList(paramObj);
        } else {
          response = await getExtParLeaDtAppList(paramObj);
        }

        const dataList = response.data.data;

        if (dataList.length > 0) {
          this.searchList = dataList;
        }

        // 조회결과없음 플래그값 세팅
        this.emptyDataFlag = this.searchList.length < 1;

        this.$store.commit('SPINNER/OFF_COMMON_SPINNER'); // 공통 스피너 OFF
        this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', false); // 모달 종료 콜백 OFF
      } catch (error) {
        console.log(error);
      }
    },

    async nextPage(item) {

      if(item.famAge > 8) {
        alert('육아휴직연장 또는 추가 신청은 8세 이하만 신청이 가능합니다');
        return;
      }

      if (item.applYn === 'N') {
        return;
      }
      if (this.GET_APPL_CD1 === applCode.LeaAbsAdd) {

        let param = {};

        let res =  await getGenderNm(param);

        if (res.data.data.genderCd === '1') {
          alert('육아휴직(추가)는 여직원만 신청 가능합니다');
          return;
        }
      }

      // console.log('item ::: ' + JSON.stringify(item));

      this.$store.commit('SET_APPL_SEQ', item.applSeq);
      this.$store.commit('SET_ORG_APPL_SEQ', item.orgApplSeq);
      this.$store.commit('SET_REF_SDATE', item.refSdate);
      this.$store.commit('SET_REF_EDATE', item.refEdate);
      this.$store.commit('SET_PER_DAY', item.famPerDay);
      this.$store.commit('SET_ADD_DAY', item.famAddDay);
      this.$store.commit('SET_PARLEV_RETURN_YMD', item.orgReinstPlanYmd);
      this.$store.commit('SET_ADD_LIMIT_TERM', item.addLimtTerm);

      if (this.GET_APPL_CD1 === applCode.LeaAbsAdd) {
        this.$router.push({
          name: routerNames.StartDateAppl,
        });
      } else {
        this.$router.push({
          name: routerNames.DateAppl,
        });
      }
    },

    useDay(item) {
      const oldDate = new Date(item.orgStaYmd);
      const newDate = new Date(item.orgTmpRestEndPlanYmd);
      let diff = Math.abs(newDate.getTime() - oldDate.getTime());
      diff = Math.ceil(diff / (1000 * 60 * 60 * 24));

      let useDay = diff + 1;

      if (isNaN(useDay)) {
        useDay = '';
      }

      return useDay;
    },
  },
  created() {
    // 공통 스피너 ON
    this.$store.commit('SPINNER/ON_COMMON_SPINNER');
    this.fetchLeaAbsApplList();
  },
  components: {
    EmptyData,
    IconBirth,
  },
};
</script>

<style scope>
td {
  text-align: center;
}
.card-list {
  padding: 20px !important;
  border: 1px solid #eee !important;
  border-radius: 12px;
}
</style>
